<!-- Password gate overlay -->
<div *ngIf="locked()" class="lock-overlay" role="dialog" aria-modal="true" aria-labelledby="lockTitle">
  <div class="lock-card">
    <h2 id="lockTitle" style="margin-top:0;">Enter Password</h2>
    <p class="lead" style="margin:0 0 .5rem; color:var(--muted);">This site is protected. Please enter the password to
      continue.</p>
    <div class="field">
      <label for="site-password">Password</label>
      <input id="site-password" type="password" (keydown.enter)="submitPassword(sitePw.value)" #sitePw>
    </div>
    <div class="actions" style="display:flex; gap:.5rem; margin-top:.5rem;">
      <button class="btn primary" type="button" (click)="submitPassword(sitePw.value)">Unlock</button>
    </div>
    <div *ngIf="passwordError()" class="error" role="alert" style="margin-top:.5rem;">{{ passwordError() }}</div>
  </div>
</div>

<!-- Site content, hidden until unlocked -->
<ng-container *ngIf="!locked()">
  <header>
    <div class="container nav" role="navigation" aria-label="Main">
      <a class="logo" href="#home">
        <img class="logo-mark"
          [src]="theme() === 'dark' ? 'assets/images/logo-white-low-res.png' : 'assets/images/logo-black-low-res.png'"
          alt="ahmo.photo logo" width="220">
      </a>
      <nav>
        <button class="menu-btn" [attr.aria-expanded]="menuOpen()" aria-controls="menu"
          (click)="toggleMenu()">Menu</button>
        <ul id="menu" role="menu" [class.open]="menuOpen()">
          <li role="none"><a role="menuitem" href="#portfolio">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <rect x="3" y="3" width="8" height="8" rx="2" stroke="currentColor" stroke-width="2" />
                <rect x="13" y="3" width="8" height="8" rx="2" stroke="currentColor" stroke-width="2" />
                <rect x="3" y="13" width="8" height="8" rx="2" stroke="currentColor" stroke-width="2" />
                <rect x="13" y="13" width="8" height="8" rx="2" stroke="currentColor" stroke-width="2" />
              </svg>
              <span>Portfolio</span>
            </a></li>
          <li role="none"><a role="menuitem" href="#services">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M3 7h18M6 7V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2M6 7l-2 12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2L18 7"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Services</span>
            </a></li>
          <li role="none"><a role="menuitem" href="#about">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                <path d="M5 21a7 7 0 0 1 14 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
              <span>About</span>
            </a></li>
          <li role="none"><a role="menuitem" href="#contact">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" stroke="currentColor"
                  stroke-width="2" />
                <path d="M22 6l-10 7L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span>Contact</span>
            </a></li>
          <!-- <li role="none"><a role="menuitem" [routerLink]="['/college-portfolio']">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M22 10v6M2 10l10-5 10 5-10 5-10-5z" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6 12v5c3.33 2 8.67 2 12 0v-5" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>College Portfolio</span>
            </a></li> -->
          <li class="menu-divider" role="separator" aria-hidden="true"></li>
          <li role="none">
            <button role="menuitem" type="button" class="icon-btn" (click)="toggleTheme()"
              [attr.aria-label]="theme() === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
              [title]="theme() === 'dark' ? 'Light theme' : 'Dark theme'">
              <span class="sr-only">Toggle theme</span>
              <!-- Moon icon for light toggle when in light theme show moon? We show the icon of the action to take next: if dark -> show sun -->
              <svg *ngIf="theme() === 'dark'" width="18" height="18" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M12 3v2M12 19v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="2" />
              </svg>
              <svg *ngIf="theme() === 'light'" width="18" height="18" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" stroke-width="2"
                  fill="none" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </li>
        </ul>
      </nav>
      <a class="btn nav-cta primary" href="#contact">Book a Shoot</a>
    </div>
  </header>

  <div class="spacer" aria-hidden="true"></div>

  <section id="home" class="hero">
    <div class="container hero-grid">
      <div>
        <div class="chips" aria-label="Genres">
          <span class="tag">Portraits</span>
          <span class="tag">Product</span>
          <span class="tag">Editorial</span>
          <span class="tag">Sports</span>
          <span class="tag">Events</span>
        </div>
        <h1>Story-driven photography with soul.</h1>
        <p class="lead">I capture authentic moments for brands and humans. Based in Sacramento, available worldwide.</p>
        <div class="actions">
          <a class="btn primary" href="#portfolio">View Work</a>
          <a class="btn ghost" href="#contact">Get in Touch</a>
        </div>
      </div>
      <div class="preview" aria-hidden="true">
        <img src="assets/img/self-portrait/self-portrait-02.jpg" alt="Autoportrait">
      </div>
    </div>
  </section>

  <section id="portfolio" class="section">
    <div class="container">
      <h2>Selected Work</h2>
      <p class="lead">A larger selection from recent commissions and personal projects.</p>

      <!-- Category Tabs -->
      <div class="tabs" role="tablist" aria-label="Portfolio categories">
        <button *ngFor="let cat of categories(); trackBy: trackByString" class="tab" role="tab" type="button"
          [class.active]="selectedCategory() === cat" [attr.aria-selected]="selectedCategory() === cat"
          (click)="selectCategory(cat)">{{ cat }}</button>
      </div>

      <div *ngIf="isLoading()" class="grid skeleton-grid" role="status" aria-live="polite" aria-busy="true">
        <span class="sr-only">Loading portfolio…</span>
        <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9]; let idx = index">
          <figure class="card skeleton" [ngClass]="(idx % 3 === 0) ? 'g-4' : 'g-3'">
            <div class="img" aria-hidden="true"></div>
            <figcaption class="overlay">
              <span class="line w-60" aria-hidden="true"></span>
              <span class="line w-40" aria-hidden="true"></span>
            </figcaption>
            <button aria-hidden="true" tabindex="-1"></button>
          </figure>
        </ng-container>
      </div>

      <div *ngIf="!isLoading() && loadError()" class="error" role="alert">
        {{ loadError() }}
      </div>

      <div class="grid" aria-live="polite" *ngIf="!isLoading() && !loadError()" [class.grid-hidden]="!gridVisible()">
        <figure class="card" *ngFor="let item of pagedItems(); let i = index; trackBy: trackBySrc"
          [ngClass]="item.span">
          <div class="img-wrap">
            <img loading="lazy" decoding="async" [src]="item.src" [alt]="item.alt" (load)="onImgLoad($event)">
            <div class="img-spinner" aria-hidden="true"><span class="spinner"></span></div>
          </div>
          <figcaption class="overlay">
            <span class="title">{{ item.title }}</span>
            <span class="meta">{{ item.meta }}</span>
          </figcaption>
          <button (click)="openLightbox(i)" [attr.aria-label]="'Open ' + item.title"></button>
        </figure>
      </div>

      <!-- Load more UI -->
      <div *ngIf="!isLoading() && !loadError() && hasMore()" class="load-more-wrap">
        <button class="btn" type="button" (click)="loadMore()">Load more</button>
        <div #sentinel class="sentinel" aria-hidden="true"></div>
      </div>
    </div>
  </section>

  <section id="services" class="section">
    <div class="container services">
      <article class="service">
        <h3>Portrait Sessions</h3>
        <p>On-location or studio portraits tailored to individuals, teams, and creatives. Direction included; delivery
          within 5–7 days.</p>
        <p><span class="tag">Starts at $350</span></p>
      </article>
      <article class="service">
        <h3>Events</h3>
        <p>Full-day coverage with a documentary approach. Custom packages, second shooter optional, online galleries and
          albums available.</p>
        <p><span class="tag">Custom Quote</span></p>
      </article>
      <article class="service">
        <h3>Commercial / Editorial</h3>
        <p>Brand stories, product features, and campaigns for print & web. Pre-production planning, lighting,
          retouching,
          and more.</p>
        <p><span class="tag">Day rates</span></p>
      </article>
    </div>
  </section>

  <section id="about" class="section">
    <div class="container about">
      <div class="portrait"><img src="assets/img/self-portrait/self-portrait-04.jpg" alt="Photographer portrait"></div>
      <div>
        <h2>About</h2>
        <p class="lead">Ahmet Hadzijusufovic is a software engineer, photographer, and competitive shooter.</p>
        <p>Born and raised in Europe, he inherited his father's deep passion for photography. One of his
          earliest memories involves holding his dad's old Kiev rangefinder camera - an aging piece of Soviet
          engineering
          that sparked a lifelong love for visual storytelling. </p>
        <p>As a teenager, Ahmet began experimenting with black-and-white photography, developing his own film using
          vintage darkroom equipment in a makeshift setup at home. </p>
        <p>While he went to study software engineering and working as a professional software engineer, he never gave up
          on his photography. Even as his days were filled with logic and algorithms, his nights often belonged to
          photography - whether capturing cityscapes, portraits, or moments of candid life through his evolving lens.
        </p>
        <p>Eventually, Ahmet emigrated to the United States, bringing with him not only his technical
          expertise but also the drive and discipline forged in his formative years. He quickly adapted, embracing his
          new home with the same determination that had shaped his journey thus far.</p>
        <p>Alongside engineering and photography, Ahmet found a new passion in competitive shooting - a discipline that
          harmonizes focus, precision, and control.</p>
        <p>Whether he's behind the camera, behind a screen, or behind the scope, Ahmet brings a sharp eye, steady hand,
          and deep-rooted passion to everything he does.</p>
        <div class="actions"><a class="btn" href="#contact">Let’s work together</a></div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <h2>Client Words</h2>
      <div class="testimonials">
        <blockquote class="quote">
          <p>“Thoughtful direction and stunning results. Our campaign exceeded expectations.”</p>
          <div class="who">— A. Rivera, Creative Director</div>
        </blockquote>
        <blockquote class="quote">
          <p>“We barely noticed the cameras, yet every moment was perfectly captured.”</p>
          <div class="who">— L. & D., Event Clients</div>
        </blockquote>
        <blockquote class="quote">
          <p>“Professional from start to finish. The headshots made our team shine.”</p>
          <div class="who">— M. Chen, HR Lead</div>
        </blockquote>
      </div>
    </div>
  </section>

  <section id="contact" class="section">
    <div class="container">
      <h2>Book a Session</h2>
      <p class="lead">Tell me about your project, preferred dates, and any inspiration references. I’ll reply within
        24 hours.</p>
      <form name="contact" method="post" data-netlify="true" netlify-honeypot="bot-field">
        <input type="hidden" name="form-name" value="contact">
        <p class="sr-only">Do not fill this out: <input name="bot-field"></p>
        <div class="field"><label for="name">Name</label><input required id="name" name="name" autocomplete="name">
        </div>
        <div class="field"><label for="email">Email</label><input required id="email" name="email" type="email"
            autocomplete="email"></div>
        <div class="field"><label for="message">Message</label><textarea required id="message" name="message"
            placeholder="Session type, dates, location, budget…"></textarea></div>
        <div class="actions">
          <button class="btn primary" type="submit">Send Inquiry</button>&nbsp;
          <a class="btn ghost" href="mailto:hello@example.com">Email directly</a>
        </div>
      </form>
    </div>
  </section>

  <footer class="footer">
    <div class="container"
      style="display:flex; justify-content:space-between; align-items:center; gap:1rem; flex-wrap:wrap;">
      <div>© {{ year }} ahmo.photo. All rights reserved.</div>
      <div class="social" aria-label="Social links">
        <a href="https://www.instagram.com/ahmophoto/" target="_blank" aria-label="Instagram">Instagram</a>
        <span aria-hidden="true">·</span>
        <a href="https://www.behance.net/ahmophoto" target="_blank" aria-label="Behance">Behance</a>
        <span aria-hidden="true">·</span>
        <a href="https://www.linkedin.com/in/ahmet-hadzijusufovic" target="_blank" aria-label="LinkedIn">LinkedIn</a>
      </div>
    </div>
  </footer>

</ng-container>

<!-- Lightbox -->
<div *ngIf="lightboxOpen()" class="lightbox-backdrop" role="dialog" aria-modal="true" aria-label="Image viewer" (click)="closeLightbox()"
  style="position:fixed;inset:0;background:rgba(0,0,0,.92);display:grid;place-items:center;z-index:60;touch-action:pan-y;"
  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
  <div class="lightbox-stage">
    <button class="close-btn" (click)="closeLightbox(); $event.stopPropagation()" aria-label="Close viewer">×</button>
    <button *ngIf="displayedItems().length > 1" class="nav-arrow prev" (click)="prevImage(); $event.stopPropagation()"
      aria-label="Previous image">&#10094;</button>
    <div class="lightbox-frame" [class.animating]="animating()" [class.dir-next]="transitionDirection()==='next'"
      [class.dir-prev]="transitionDirection()==='prev'">
      <img class="lightbox-img" [class.is-loading]="lightboxLoading()" [src]="lightboxSrc()" alt="Expanded work"
        [attr.aria-describedby]="currentLightboxItem() ? 'lb-cap' : null">
      <div *ngIf="currentLightboxItem() as ci" id="lb-cap" class="lightbox-caption">
        <h3 class="lb-title">{{ ci.title }}</h3>
        <p class="lb-meta" *ngIf="ci.meta">{{ ci.meta }}</p>
        <p class="lb-cat" *ngIf="ci.category">{{ ci.category }}</p>
      </div>
    </div>
    <button *ngIf="displayedItems().length > 1" class="nav-arrow next" (click)="nextImage(); $event.stopPropagation()"
      aria-label="Next image">&#10095;</button>
    <div class="counter" aria-live="polite">{{ (lightboxIndex() ?? 0) + 1 }} / {{ displayedItems().length }}</div>
  </div>
</div>